import {SecutiryPolicyApiPrefix as poApiPreFix} from '~/utils/restApi'

export const state = () => ({
  apiPreFix: `${poApiPreFix}`,
  apiQoSInterface: 'qos/able/interfaces', // 설정 가능한 인터페이스 목록 조회
  apiQoSProfileList: 'qos/all/profiles', // QoS 프로파일 설정 조회
  apiQoSPolicyList: 'qos/all/policies', // QoS 정책 목록을 조회
  qosApi: {
    url: `${poApiPreFix}/qos/policies`,
    config: {
      loading: false,
      successAlert: false
    }
  },
  apiQoSPolicy: 'qos/policies',
  finalCommand: `${poApiPreFix}/command/qos-policies`,
  qosPolicy: {
    qos_ifc_cm_id: null,
    qos_ifc_id: null,
    qos_ifc_name: '',
    qos_ifc_sync_use_yn: 0,
    qos_ifc_use: 0,
    qos_prf: [],
    device_id_list: []
  },
  qosProfileList: [],
  selPolicyList: [],
  qosInterfaceList: [],
  qosPolicyList: []
})

export const mutations = {
  initQoSPolicy (state) {
    state.qosPolicy = {
      qos_ifc_cm_id: null,
      qos_ifc_id: null,
      qos_ifc_name: '',
      qos_ifc_sync_use_yn: 0,
      qos_ifc_use: 0,
      qos_prf: [],
      device_id_list: []
    }
  },
  initQoSPolicyList (state) {
    state.selPolicyList = []
    state.qosInterfaceList = []
    state.qosPolicyList = []
  },
  setQoSPolicyList (state, data) {
    state.qosPolicyList = _.cloneDeep(data)
  },
  setQoSPolicy (state, data) {
    state.qosPolicy = data
  },
  setQoSInterfaceList (state, data) {
    state.qosInterfaceList = _.cloneDeep(data)
  },
  setQoSProfileList (state, data) {
    state.qosProfileList = _.cloneDeep(data)
  },
  delQoSPolicies (state, data) {
    _.forEach(data, (d) => {
      _.forEach(state.qosPolicyList, (d2, i2) => {
        if (d.qos_prf_id === d2.qos_prf_id) {
          state.qosPolicyList.splice(i2, 1)
          return false
        }
      })
    })
  }
}

export const actions = {
  // QoS 정책 목록 조회
  async getQoSPolicyList ({commit, state}) {
    const url = `${state.apiPreFix}/${state.apiQoSPolicyList}`
    const res = {code: 'nok'}

    try {
      const {code, result} = await this.$axios.$get(
        url,
        state.qosApi.config
      )

      if (code === 'ok') {
        commit('setQoSPolicyList', result)
      }

      return {code, result}
    } catch (e) {
      // res.code = e
      res.result = e
    }
    return res
  },
  async getQoSInterfaceList ({commit, state}, {loadingShow = true, loadingHide = true}) {
    const uri = `${state.apiPreFix}/${state.apiQoSInterface}`
    const res = {code: 'nok'}

    try {
      const {code, result} = await this.$axios.$get(uri, {loadingShow: loadingShow, loadingHide: loadingHide})
      if (code === 'ok') {
        commit('setQoSInterfaceList', result)
      }

      return {code, result}
    } catch (e) {
      // res.code = e
      res.result = e
    }

    return res
  },
  async getQoSProfileList ({commit, state}, {loadingShow = true, loadingHide = true}) {
    const uri = `${state.apiPreFix}/${state.apiQoSProfileList}`
    const res = {code: 'nok'}

    try {
      const {code, result} = await this.$axios.$get(uri, {loadingShow: loadingShow, loadingHide: loadingHide})

      if (code === 'ok') {
        commit('setQoSProfileList', result)
      }

      return {code, result}
    } catch (e) {
      // res.code = e
      res.result = e
    }

    return res
  },
  // QoS 정책 설정 목록 일괄 수정. - 동기화 여부 단일/다중 수정.
  async markedSyncList ({commit, state}, items) {
    const {code, result} = await this.$axios.$put(
      `${state.apiPreFix}/${state.apiQoSPolicy}/sync`,
      items,
      state.qosApi.config
    )
    return {code, result}
  },
  // QoS 정책 설정 목록 일괄 수정. - 실행 여부 단일/다중 수정.
  async markedUseList ({commit, state}, items) {
    const {code, result} = await this.$axios.$put(
      `${state.apiPreFix}/${state.apiQoSPolicy}/use`,
      items,
      state.qosApi.config
    )
    return {code, result}
  },
  async getQoSPolicy ({commit, state}, {qosIfcCmId}) {
    const url = `${state.qosApi.url}/${qosIfcCmId}`
    const res = {code: 'nok'}

    try {
      const {code, result} = await this.$axios.$get(
        url,
        state.qosApi.config
      )

      if (res.code === 'ok') {
        commit('setQoSPolicy', result)
      }

      return {code, result}
    } catch (e) {
      // res.code = e
      res.result = e
    }
    return res
  },
  // AoS 정책 설정 추가/수정
  async setQosPolicy ({commit, state}, {items, qosIfcCmId = null}) {
    const
      isAdd = _.isNil(qosIfcCmId),
      method = (isAdd) ? '$post' : '$put'

    const data = _.assignIn(
      {
        qos_ifc_sync_use_yn: items.qos_ifc_sync_use_yn,
        qos_prf_id_1: items.qos_prf_id_1,
        qos_prf_id_2: items.qos_prf_id_2,
        qos_prf_id_3: items.qos_prf_id_3,
        qos_ifc_use: items.qos_ifc_use,
        device_id_list: _.map(items.device_id_list, 'device_id')
      },
      isAdd ? {qos_ifc_id: items.qos_ifc_id} : {qos_ifc_cm_id: items.qos_ifc_cm_id})

    const res = await this.$axios[method](
      state.qosApi.url,
      data,
      _.cloneDeep(state.qosApi.config)
    )
    return res
  },
  async delQoSPolicies ({ commit, state }, [items]) {
    let res = {code: 'ok', result: {}}

    try {
      res = await this.$axios.$delete(
        state.qosApi.url,
        _.assignIn({ data: items }, _.cloneDeep(state.qosApi.config))
      )

      return res
    } catch (e) {
      res = {code: 'nok', result: e}
    }
    return res
  },
  // QoS 정책 설정 적용/취소
  async finalCommand ({commit, state}, {type, loadingShow = false}) {
    if (!_.includes(['apply', 'cancel'], type)) return 'nok'
    try {
      const param = _.assign({ loadingShow: loadingShow }, (_.eq(type, 'apply')) ? { applyMsg: true } : { cancelMsg: true })
      const {code, result} = await this.$axios.$put(`${state.finalCommand}/${type}`, null, param)
      if (code !== 'ok') {
        return result.msg
      }
      return code
    } catch (e) {
      this.$log('[QOS] finalCommand Exception -> ', e)
      return e
    }
  }
}

export const getters = {}

export const strict = false
